
export enum FavoriteLinkType {
  'dashboard' = 'dashboard',
  'chart' = 'chart',
  'map' = 'map',
  'object' = 'object',
  'config' = 'config',
  'history' = 'history',
  'list' = 'list',
  'users' = 'users',
  'profile' = 'profile',
}


const IconsPaths = new Map();

IconsPaths.set(FavoriteLinkType.dashboard, ['#!/app/dashboards']);
IconsPaths.set(FavoriteLinkType.chart, ['#!/main/charts']);
IconsPaths.set(FavoriteLinkType.map, ['#!/main/map']);
IconsPaths.set(FavoriteLinkType.object, ['#!/app/db/unit', '#!/app/db/object']);
IconsPaths.set(FavoriteLinkType.config, ['#!/app/db/typicalconfig',
  '#!/app/db/ustasdevice',
  '#!/app/db/controlprocedure',
  '#!/app/db/zone',
  '#!/app/db/paramcategory',
  '#!/app/db/controllermodel',
  '#!/app/db/paramtag',
  '#!/main/import',
  '#!/main/export']);
IconsPaths.set(FavoriteLinkType.history, ['#!/main/logs']);
IconsPaths.set(FavoriteLinkType.list, [
  '#!/app/db/iconsets',
  '#!/app/db/imgsets',
  '#!/app/db/event',
  '#!/app/db/command',
  '#!/app/db/collectorserver']);
IconsPaths.set(FavoriteLinkType.users, ['#!/app/db/user', '#!/app/db/usergroup', '#!/app/db/sdirrole']);
IconsPaths.set(FavoriteLinkType.profile, ['#!/main/user/profile', '#!/app/user/userevent', '#!/app/user/profileusernotify']);


export function findIconClassByPath(url: string) {
  let result = '';
  IconsPaths.forEach((paths, iconClass) => {
    if (paths.find((path) => url.search(path) !== -1)) {
      result = iconClass;
    }
  });
  return result;
}
